<template>
  <div class="tongxin-modal" :class="{ show: isVisible }">
    <div class="tongxin-modal__content">
      <div class="tongxin-modal__header">
        <div class="tongxin-modal__icon result-modal-icon" :class="{ success: state.isSuccess, error: !state.isSuccess }">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <template v-if="state.isSuccess">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </template>
            <template v-else>
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </template>
          </svg>
        </div>
        <h2 class="tongxin-modal__title">{{ state.title }}</h2>
      </div>
      <div class="tongxin-modal__body">
        <p class="tongxin-modal__text">{{ state.message }}</p>
        <div class="error-reason" v-if="state.errorReason">
          <div class="error-reason-title">錯誤原因</div>
          <div class="error-reason-text">{{ state.errorReason }}</div>
        </div>
      </div>
      <div class="tongxin-modal__buttons">
        <button class="btn btn-primary" @click="handleClose" style="flex-grow: 1">確定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultModal',
  data() {
    return {
      isVisible: false,
      state: {
        isSuccess: true,
        title: '',
        message: '',
        errorReason: ''
      }
    }
  },
  methods: {
    /**
     * 顯示 Modal
     */
    show({ isSuccess, title, message, errorReason = '' }) {
      this.state = {
        isSuccess,
        title,
        message,
        errorReason
      }
      this.isVisible = true
    },

    /**
     * 關閉 Modal
     */
    handleClose() {
      this.isVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
/* Modal */
.tongxin-modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 2000;
  justify-content: center;
  align-items: center;

  &.show {
    display: flex;
  }

  &__content {
    background: #fff;
    border-radius: 16px;
    padding: 32px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 10px 40px rgba(0,0,0,0.3);
    animation: modalSlideIn 0.3s ease-out;
  }

  &__header {
    text-align: center;
    margin-bottom: 24px;
  }

  &__icon {
    width: 60px;
    height: 60px;
    background: #fee2e2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
  }

  &__icon svg {
    width: 30px;
    height: 30px;
    color: #dc2626;
  }

  &__title {
    font-size: 26px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
  }

  &__body {
    margin-bottom: 24px;
  }

  &__text {
    font-size: 20px;
    color: #666;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 20px;
  }

  &__buttons {
    display: flex;
    justify-content: center;
    gap: 12px;

    .btn + .btn {
      margin-left: auto;
    }
  }
}

/* 結果 Modal 樣式 */
.result-modal-icon.success {
  background: #d1fae5;
}

.result-modal-icon.success svg {
  color: #10b981;
}

.result-modal-icon.error {
  background: #fee2e2;
}

.result-modal-icon.error svg {
  color: #dc2626;
}

.error-reason {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 16px;
  text-align: left;
}

.error-reason-title {
  font-size: 16px;
  font-weight: bold;
  color: #dc2626;
  margin-bottom: 8px;
}

.error-reason-text {
  font-size: 16px;
  color: #991b1b;
  line-height: 1.6;
}

@media (max-width: 767px) {
  .tongxin-modal__content {
    padding: 24px;
  }

  .tongxin-modal__title {
    font-size: 22px;
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
